import { forwardRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import LdsIcon from '../LdsIcon/index.jsx';

const LdsButton = forwardRef(function LdsButton({
  children,
  classes = undefined,
  className = '',
  clearDefaultClasses = false,
  disabled = false,
  disableIconSpace = false,
  icon = undefined,
  iconOnly = false,
  iconPosition = 'after',
  linkButton = false,
  onClick,
  type = 'button',
  ...rest
}, ref) {
  const IconElement = () => {
    if (!icon) return '';
    return (
      <LdsIcon
        name={icon}
        className={cn(
          'button-icon',
          {
            [`${iconPosition}`]: children,
          }
        )}
        inline
        decorative
      />
    );
  };

  // Creates a spacer element to add a single text non-breaking space character
  // between the "Easy Icon" and the text of the link
  const IconSpacer = () => {
    // If the developer explicity disabled the icon spacer, do it
    if (disableIconSpace) return '';
    // If it's an "icon only" link (or button link) there should never be an additional space character
    if (iconOnly) return '';
    // Otherwise there should usually be a space character between the link content and the easy icon
    return (<span className="lds-button-icon-spacer">&nbsp;</span>);
  };

  return (
    <button
      ref={ref}
      onClick={onClick}
      type={type}
      className={cn(
        {
          'lds-button': !linkButton && !clearDefaultClasses,
          'lds-link': linkButton,
          [`${classes}`]: classes,
          'icon-only': iconOnly,
          disabled,
        },
        className
      )}
      disabled={disabled}
      {...rest}
    >
      {icon && iconPosition === 'before' && <IconElement />}
      {icon && iconPosition === 'before' && <IconSpacer />}
      {children}
      {icon && iconPosition === 'after' && <IconSpacer />}
      {icon && iconPosition === 'after' && <IconElement />}
    </button>
  );
});

export default LdsButton;

LdsButton.propTypes = {
  classes: PropTypes.string,
  clearDefaultClasses: PropTypes.bool,
  disabled: PropTypes.bool,
  disableIconSpace: PropTypes.bool,
  icon: PropTypes.string,
  iconOnly: PropTypes.bool,
  iconPosition: PropTypes.oneOf(['before', 'after']),
  linkButton: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};
